export const PLATFORM_NAME = 'Passion Creators';
